<template>
    <div class="up-box" :class="mobileDevice ? 'mobileDevice' : ''">
        <div class="title-box">
            <!-- <div class="m-title">Upload a PDF</div> -->
            <div class="s-title" v-if="!isUpload">
                Upload a PDF file to use the sildesOrator
            </div>
            <div class="smart" v-else>
                <div class="left">Smart document analysis in progress...</div>
                <div class="right">
                    <Progress :percent="percent" hide-info />
                </div>
            </div>
        </div>
        <div class="up-content" v-if="!isUpload">
            <div class="item">
                <img class="up-icon" src="@/assets/upload.png" alt="" />
                <div class="tip">Upload a file or drag and drop here</div>
                <div class="tip1">pdf，up to 20MB</div>
                <input
                    class="file-select"
                    :type="!isUpload ? 'file' : 'txt'"
                    @change="handleChange"
                    title=""
                    accept=".pdf" />
            </div>
        </div>
        <div class="up-content noborder" v-else>
            <div class="content-box">
                <!-- <div class="item1" v-if="!isUploadImgToCanvas">
                    <div class="tips">
                        🚀Document is uploading, <br />your knowledge base and
                        script will be ready soon...
                    </div>
                    <div class="tips1">Hang tight, magic is on the way!</div>
                </div> -->

                <div class="carousel">
                    <div class="tips-carousel" ref="carousel">
                        <img src="@/assets/carousel/icon9.png" alt="" ref="img" />
                        <img
                            src="@/assets/carousel/icon1.png"
                            alt=""
                            />

                        <img src="@/assets/carousel/icon2.png" alt="" />

                        <img src="@/assets/carousel/icon3.png" alt="" />

                        <img src="@/assets/carousel/icon4.png" alt="" />

                        <img src="@/assets/carousel/icon5.png" alt="" />
                        <img src="@/assets/carousel/icon6.png" alt="" />
                        <img src="@/assets/carousel/icon7.png" alt="" />
                        <img src="@/assets/carousel/icon8.png" alt="" />
                        <img src="@/assets/carousel/icon9.png" alt="" />
                        <img src="@/assets/carousel/icon1.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { Message } from "view-ui-plus";
import { detUUID } from "@/utils/utils";
import { uploadPDFURL } from "@/api";
import { uploadFileToGCS } from "@/utils/gcsUpload";
import { PDFload, getPDFPages } from "@/utils/pdfload";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
import { useStore } from "vuex";
const store = useStore();
const isUpload = computed(() => store.state.file.isUpload);
const membershipRights = computed(() => {
    return store.state.user.membershipRights;
});
const emits = defineEmits(["close"]);
import { useMixinMobileDevice } from "@/mixins/mobileDevice";
const { mobileDevice, Orientation } = useMixinMobileDevice();
const carousel = ref(null);
const img = ref(null);
const percent = ref(0);
const timeId1 = ref(null);
const timeId2 = ref(null);
// 处理文件选择
const isUploadImgToCanvas = ref(false);
const handleClick = () => {
    emits("close");
    Message.destroy();
    router.push("/price");
};

onMounted(() => {});

const loadImgchange = () => {
    let x = 0;
    const marginRight = 20;

    // 这里加个延时确保图片加载完成
    setTimeout(() => {
        if (!img.value) return;

        const imgWidth = img.value.getBoundingClientRect().width || 615; // 获取一张图片的宽度
        const moveStep = imgWidth + marginRight;

        timeId2.value = setInterval(() => {
            x += 1;

            if (carousel.value) {
                carousel.value.style.transition = "all 0.5s";
                carousel.value.style.transform = `translateX(${
                    -x * moveStep
                }px)`;

                if (x >= 9) {
                    // 注意是x >= 3，不是x*moveStep>=totalStep
                    setTimeout(() => {
                        carousel.value.style.transition = "none";
                        x = 0;
                        carousel.value.style.transform = `translateX(0px)`;
                    }, 500); // 等动画0.5秒完成再跳
                }
            }
        }, 5000);
    }, 2000); // 延时100ms，等图片渲染好
};

const handleChange = (e) => {
    store.dispatch("file/isUpload", true);
    const [file] = e.target.files;
    console.log(file);
    console.log(file.name);
    const uuid = detUUID();
    let pdfUrl = `${uuid}/doc/${uuid}_${file.name}`;
    let pdfName = file.name.substring(0, file.name.lastIndexOf("."));
    console.log(pdfUrl);

    if (!["application/pdf"].includes(file.type)) {
        Message.warning({
            background: true,
            content: "Please upload PDF file",
            duration: 5,
        });
        store.dispatch("file/isUpload", false);
        return;
    }

    if (file.size >= 1024 * 1024 * 20) {
        console.log("超20M");
        Message.warning({
            background: true,
            content: "File size exceeds 20M",
            duration: 5,
        });
        store.dispatch("file/isUpload", false);
        return false;
    }

    var reader = new FileReader();
    reader.readAsDataURL(file); //将文件读取为 DataURL
    reader.onload = function () {
        getPDFPages(reader.result).then((page) => {
            console.log(page);
            console.log(membershipRights.value);
            if (
                membershipRights.value.levelName == "Free" &&
                membershipRights.value.documentPageNum < page
            ) {
                store.dispatch("user/set_recharge", {
                    recharge: true,
                    rechargeText:
                        "Document page limit exceeded. Upgrade your subscription to unlock all features.",
                }); //提示充值
                store.dispatch("file/isUpload", false);
                throw new Error("");
            } else {
                console.log("-----------");
                percentIntervals()
                loadImgchange();
                uploadFileToGCS(file, pdfUrl).then((res) => {
                    console.log("上传成功1");
                    var reader = new FileReader();
                    reader.readAsDataURL(file); //将文件读取为 DataURL
                    reader.onload = function () {
                        //文件读取成功完成时触发
                        // console.log(reader.result)
                        PDFload(reader.result, uuid, (pre) => {
                            console.log(pre);
                        })
                            .then((e) => {
                                isUploadImgToCanvas.value = true;
                                console.log(e);
                                e.sort((a, b) => {
                                    let numA = parseInt(
                                        a.match(/_(\d+).jpeg$/)[1],
                                        10
                                    );
                                    let numB = parseInt(
                                        b.match(/_(\d+).jpeg$/)[1],
                                        10
                                    );
                                    return numA - numB;
                                });

                                console.log(e);
                                uploadPDFURL({
                                    pdfUrl,
                                    pdfName,
                                    pdfPageUrl: e,
                                })
                                    .then((r) => {
                                        console.log(r);
                                        if (r.code == 200) {
                                            percent.value = 100;
                                            clearIntervals();
                                            store.dispatch(
                                                "file/setFileID",
                                                r.data
                                            );
                                            store.dispatch("app/setUpStep", 1);
                                            store.dispatch(
                                                "file/isUpload",
                                                false
                                            );
                                        } else {
                                            store.dispatch(
                                                "file/isUpload",
                                                false
                                            );
                                        }
                                    })
                                    .catch(() => {
                                        clearIntervals();
                                        store.dispatch("file/isUpload", false);
                                    });
                            })
                            .catch(() => {
                                console.log("上传失败");
                            });
                    };
                });
            }
        });
    };
};

const percentIntervals = () => {
    timeId1.value = setInterval(() => {
        if (percent.value <= 90) {
            percent.value += 0.5;
        }
    }, 300);
};

const clearIntervals = () => {
    store.dispatch("file/isUpload", false);
    isUploadImgToCanvas.value = false;
    percent.value = 0;
    clearInterval(timeId1);
    clearInterval(timeId2);
};
</script>
<style lang="less">
.up-box {
    .ivu-progress-inner {
        background-color: rgba(241, 241, 241, 1) !important;
    }
}
</style>
<style lang="less" scoped>
.up-box {
    height: 450px;
    .close {
        position: absolute;
        top: -30px;
        right: 0px;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px 4px 4px 4px;
        cursor: pointer;

        &:hover {
            background: rgba(239, 239, 239, 1);
        }

        img {
            width: 16px;
            height: 16px;
        }
    }

    .title-box {
        // display: flex;
        // align-items: center;
        .m-title {
            font-size: 20px;
            font-weight: 500;
            color: #31302eff;
            margin-right: 10px;
        }
        .s-title {
            font-size: 14px;
            color: #4945ffff;
            text-align: center;
        }

        .smart {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .left {
                font-size: 16px;
                font-weight: 500;
                color: rgba(49, 48, 46, 1);
            }
            .right {
                width: 380px;
            }
        }
    }

    .up-content {
        height: 402px;
        width: 100%;
        border: 1px dashed #4945ffff;
        border-radius: 8px;
        margin-top: 20px;
        position: relative;
        overflow: hidden;
        &.noborder {
            border: none;
        }
        .item {
            height: 402px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            &:hover {
                background: #f4f4ffff;
            }
            .up-icon {
                width: 64px;
                height: 64px;
                margin-bottom: 40px;
            }
            .file-select {
                width: 100%;
                height: 100%;
                opacity: 0;
                cursor: pointer;
                position: absolute;
                left: 0;
                top: 0;
            }

            .tip {
                font-size: 16px;
                color: #31302eff;
            }

            .tip1 {
                font-size: 14px;
                color: #31302e99;
                text-decoration: dashed;
                margin-top: 16px;
                text-decoration: underline;
            }
        }
        .content-box {
            height: 100%;
            // background: rgba(244, 244, 255, 1);
            .carousel {
                .tips-carousel {
                    height: 402px;
                    display: flex;
                    transition: all 0.5s;
                    img {
                        width: 613px;
                        margin-right: 20px;
                        height: 100%;
                        object-fit: cover;
                        &:nth-last-child(1) {
                            margin-right: 0;
                        }
                    }
                }
            }
        }
        .item1 {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            height: 100%;
            background: rgba(244, 244, 255, 1);
            .tips {
                // width: 488px;
                font-size: 24px;
                color: rgba(49, 48, 46, 1);
                font-weight: 500;
                text-align: center;
            }
            .tips1 {
                font-size: 16px;
                font-weight: 400;
                color: rgba(49, 48, 46, 1);
                margin-top: 30px;
            }
            .loading {
                width: 44px;
                height: 44px;
                margin-right: 26px;
                animation: load 2s linear infinite;
            }

            @keyframes load {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        }
    }

    &.mobileDevice {
        height: 380px;
        .title-box {
            flex-direction: column;
        }
        .up-content {
            height: 300px;
        }
    }
}
</style>
